
<template>
  <vx-card title="Orders">
    <div class="flex flex-wrap justify-between items-center">
      <div class="w-100">
        <vs-button
          class="mb-4 md:mb-0 mr-4"
          icon-pack="feather"
          icon="icon-plus"
          type="border"
          to="/add-order"
          style="float: right"
          >Add order</vs-button
        >
        <vs-button
          class="mb-4 md:mb-0 mr-4 fas fa-sync"
          icon-pack="feather"
          icon="icon-refresh-ccw"
          type="border"
          @click="getOrders()"
          style="float: right"
          >Refresh</vs-button
        >
      </div>
    </div>
    <div>
      <div class="col">
        <b-form-checkbox v-model="showClosed">
          Show closed orders
        </b-form-checkbox>
        <b-table striped hover :items="getOrdersToDisplay()" :dark="darkTheme">
          <template v-slot:cell(document_link)="row">
            <a
              :href="row.value"
              v-if="row.value"
              rel="noopener noreferrer"
              target="_blank"
              >View</a
            >
          </template>
          <template v-slot:cell(customer_order_number)="row">
            {{row.value}}
          </template>
          <template v-slot:cell(order_no)="row">
            {{ row.value }}
          </template>
          <template v-slot:cell(date_ordered)="row">
            <span v-if="row.value"> {{ getDateString(row.value) }}</span>
          </template>
          <template v-slot:cell(total)="row">
            <span v-if="row.value != 'To Be Calculated'">
              {{ "$" + row.value.toFixed(2) }}</span
            >
          </template>
          <template v-slot:cell(state)="row">
            {{
              row.value == 0
                ? "Open"
                : row.value == 1
                ? "Closed"
                : "In Progress"
            }}
          </template>
        </b-table>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      customerOrders: [],
      showClosed: false,
      fields: ["document_link","customer_order_number", "order_no", "date_ordered", "total", "state"],
      darkTheme: false,
    };
  },
  mounted() {
    this.getUserDetails();
    this.getOrders();
  },
  methods: {
    getOrdersToDisplay() {
      if (this.showClosed) {
        return this.customerOrders;
      } else {
        return this.customerOrders.filter((order) => order.state != 1);
      }
    },
    getOrders() {
      this.showLoadingSpinner();

      const endPoint = this.$store.getters.isUserCustomer
        ? "Rest/myCustomersCustomerOrders"
        : "Rest/myCustomerOrders";

      const urlWithParams = new URL(
        `${process.env.VUE_APP_BASE_URL}${endPoint}`
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append("state", -1);
      if (this.$store.getters.isUserCustomer) {
        urlWithParams.searchParams.append(
          "customerName",
          this.$store.getters.userCustomer
        );
      }

      fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            const orders = data.order;
            let newOrders = [];
            orders.forEach((order) => {
              // Not processed yet
              if (order.state == 1) {
                newOrders.push({
                  document_link: null,
                  order_no: order.order_number,
                  customer_order_number: order.order_reference,
                  date_ordered: new Date(),
                  total: "To Be Calculated",
                  state: order.open_state,
                });
              } else {
                newOrders.push({
                  document_link: order.pdf_url,
                  order_no: order.order_number,
                  customer_order_number: order.order_reference,
                  date_ordered: new Date(parseInt(order.order_date.substr(6))),
                  total: order.order_amount,
                  state: order.open_state,
                });
              }
            });
            // sort in descending order of order number (show newest first)
            newOrders.sort((a, b) => b.order_no - a.order_no);
            this.customerOrders = newOrders;
          }
          this.hideLoadingSpinner();
        });
    },
  },
};
</script>

<style scoped>
.orderRow {
  border-bottom: 1px solid black;
  padding: 20px;
}
</style>
